<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 6,
    },
    primaryColor: {
      type: String,
      default: '#F9FAFF',
    },
    secondaryColor: {
      type: String,
      default: '#D8DFF6',
    },
  },
};
</script>

<template>
  <content-loader
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    :speed="2"
    :primaryColor="primaryColor"
    :secondaryColor="secondaryColor"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="0" y="0" :width="width" :height="height" rx="2" ry="2" />
  </content-loader>
</template>
